import { IconButton } from '@mui/material';
import ChargesAndPaymentsIcon from '@mui/icons-material/AttachMoneyTwoTone';
import { ConsignmentTab } from '@/ConsignmentDetails/types';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { setModalSearchParameters } from '@hooks/useModalParams';

import styles from './ApplicationLink.module.css';

interface ChargesAndPaymentsLinkProps {
  leg: DispatchLeg;
}

/**
 * Component for rendering a Charages and Payments link.
 */
export default function ChargesAndPaymentsLink({ leg }: ChargesAndPaymentsLinkProps) {
  const handleBtnClick = () => {
    setModalSearchParameters({
      form: 'consignmentDetails',
      formId: String(leg.csnId),
      tab: ConsignmentTab[ConsignmentTab.ChargesAndPayments]
    });
  };

  return (
    <IconButton
      className={styles['icon-btn']}
      onClick={handleBtnClick}>
      <ChargesAndPaymentsIcon fontSize='inherit' />
    </IconButton>
  );
}
